export const USERHOURSLIST_SEARCH = 'USERHOURSLIST_SEARCH';
export const USERHOURSLIST_PAGE = 'USERHOURSLIST_PAGE';
export const USERHOURSLIST_PERIOD = 'USERHOURSLIST_PERIOD';
export const USERHOURSLIST_YEAR = 'USERHOURSLIST_YEAR';